import { useRouter } from 'next/navigation';
import { useCallback, useMemo, useState } from 'react';
import { useIsMobile } from '../use-is-mobile';

export const useSignInPage = props => {
  const { isMobile } = useIsMobile();

  const { createAccountPageUrl = 'create-account' } = props;
  const [username, setUsername] = useState('');

  const router = useRouter();

  const historyState = useMemo(() => {
    // TODO:
    return {};
    // return history && history.location.state ? history.location.state : {}
  }, []);

  const handleShowCreateAccount = useCallback(() => {
    if (createAccountPageUrl) {
      router.push(createAccountPageUrl, historyState);
    }
  }, [createAccountPageUrl, router, historyState]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleForgotPassword = useCallback(() => {
    router.push('/forgot-password');
  }, [router]);

  const handleCancel = useCallback(() => {}, []);

  const handleCreateAccount = useCallback(() => {}, []);

  const handleAccountCreation = useCallback(() => {}, []);

  const onLoginSuccess = useCallback(() => {
    const link = isMobile ? '/personal-center-mobile' : '/order-history';

    router.push(link);
  }, [isMobile, router]);

  const onCreateAccountSuccess = useCallback(() => {
    setIsModalOpen(true);
  }, [setIsModalOpen]);

  const onButtonClick = useCallback(() => {
    router.push('/');
  }, [router]);

  const onModalCancel = useCallback(() => {
    setIsModalOpen(false);
    router.push('/');
  }, [router]);

  return {
    handleAccountCreation,
    handleCreateAccount,
    handleForgotPassword,
    handleCancel,
    updateUsername: setUsername,
    username,
    showCreateAccount: handleShowCreateAccount,
    onLoginSuccess,
    onCreateAccountSuccess,
    isModalOpen,
    onModalCancel,
    onButtonClick,
  };
};
